import { clientMsgIdFor } from "../cache/outbox.js";
import { cyboState } from "../plugins/agents/state.svelte.js";
import { reportUiFailure } from "../report-failure.js";
import { channelSubject, dmPeerSubject, workspaceSubject } from "../report-subject.js";

// `connected`: authenticated when armed and not dropped since (markSendWatchdogsDropped).
export interface SendWatch {
  timer: ReturnType<typeof setTimeout>;
  surface: "channel" | "dm";
  targetId: string;
  workspaceId: string | undefined;
  connected: boolean;
}

export interface UnconfirmedSend extends Pick<SendWatch, "surface" | "targetId" | "workspaceId"> {
  windowMs: number;
  localId: string;
  connectedThroughout: boolean;
}

// The send watchdog's report: no echo while connected is a fault; offline or a drop
// in the window is the expected transient (the outbox replays it on reconnect).
export function reportSendUnconfirmed(send: UnconfirmedSend): void {
  const target =
    send.surface === "channel"
      ? channelSubject(send.targetId)
      : dmPeerSubject(send.targetId, cyboState.list);
  reportUiFailure(
    "chat.send_unconfirmed",
    new Error("no server echo within the send window"),
    {
      ...workspaceSubject(send.workspaceId),
      ...target,
      surface: send.surface,
      windowMs: send.windowMs,
      clientMsgId: clientMsgIdFor(send.localId),
    },
    send.connectedThroughout ? {} : { failureKind: "transient" },
  );
}
